import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { useEffect } from 'react';
import { toast } from 'sonner';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    // Show message when redirecting unauthenticated users
    if (!loading && !user) {
      toast.error('Please log in to access this page');
    }
  }, [loading, user]);

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="spinner mb-4"></div>
        <p className="text-slate-400 text-lg">Loading...</p>
        <p className="text-slate-500 text-sm mt-2">Checking authentication</p>
      </div>
    );
  }

  if (!user) {
    // Redirect to login page with the intended destination
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return children;
};

export default ProtectedRoute;